import { BufferAttribute, BufferGeometry, Uint16BufferAttribute } from "three";
import { InterleavedBufferUtil } from "./InterleavedBufferUtil";
var BufferGeometryUtil = /** @class */ (function () {
    function BufferGeometryUtil() {
    }
    BufferGeometryUtil.merge = function (geometries, attrsOrder, materialIndices) {
        var result = new BufferGeometry();
        var len_i = geometries.length;
        // ------------------------------ Vertices
        var totalCount = 0;
        var vertexCounts = geometries.map(function (geometry) {
            var count = geometry.attributes.position.count;
            totalCount += count;
            return count;
        });
        var totalSize = 0;
        attrsOrder.itemSizes.forEach(function (size) {
            totalSize += size;
        });
        // InterleavedBufferなので配列は1つ
        var vertices = new Float32Array(totalCount * totalSize);
        var index = 0;
        // メッシュ毎
        for (var i = 0; i < len_i; i++) {
            var geometry = geometries[i];
            // 頂点毎
            var len_j = vertexCounts[i];
            for (var j = 0; j < len_j; j++) {
                // 属性毎
                var len_k = attrsOrder.itemSizes.length;
                for (var k = 0; k < len_k; k++) {
                    var len_l = attrsOrder.itemSizes[k];
                    var array = geometry.attributes[attrsOrder.names[k]].array;
                    var attrsIndex = j * len_l;
                    // 属性サイズ毎
                    for (var l = 0; l < len_l; l++) {
                        vertices[index++] = array[attrsIndex + l];
                    }
                }
            }
        }
        // ------------------------------ Indices
        totalCount = 0;
        var indicesCounts = geometries.map(function (geometry) {
            var count = geometry.index.count;
            totalCount += count;
            return count;
        });
        var indices = new Float32Array(totalCount);
        var offset = 0;
        index = 0;
        // メッシュ毎
        for (var i = 0; i < len_i; i++) {
            var geometry = geometries[i];
            var array = geometry.index.array;
            // 描画インデックスごと
            var len_j = geometry.index.count;
            for (var j = 0; j < len_j; j++) {
                indices[index++] = array[j] + offset;
            }
            offset += vertexCounts[i];
        }
        result.setIndex(new Uint16BufferAttribute(indices, 1));
        // ------------------------------ Group
        // マルチマテリアルを使用したい場合
        if (materialIndices) {
            // materialIndices は [0, 0, 1, 2, 2, 2] のように昇順ソート済みの前提、それに合わせて Meshes 側もソート済みの前提
            var start = 0;
            var count = 0;
            var prevIndex = 0;
            for (var i = 0; i < len_i; i++) {
                var currentIndex = materialIndices[i];
                if (prevIndex !== currentIndex) {
                    result.groups.push({
                        start: start,
                        count: count,
                        materialIndex: prevIndex
                    });
                    start += count;
                    count = 0;
                }
                count += indicesCounts[i];
                prevIndex = currentIndex;
            }
            result.groups.push({
                start: start,
                count: count,
                materialIndex: prevIndex
            });
        }
        InterleavedBufferUtil.setInterleavedBuffer(result, vertices, attrsOrder);
        return result;
    };
    BufferGeometryUtil.setSingleColor = function (geometry, color) {
        var count = geometry.attributes.position.count;
        var bufferAttribute = new BufferAttribute(new Float32Array(count * 3), 3);
        geometry.setAttribute('color', bufferAttribute);
        for (var i = 0; i < count; i++) {
            bufferAttribute.setXYZ(i, color.r, color.g, color.b);
        }
    };
    return BufferGeometryUtil;
}());
export { BufferGeometryUtil };
